'use client';
import { BottomNavigation, BottomNavigationAction, Box, CssBaseline, Paper, Stack } from '@mui/material';

import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { useRouter } from 'next/router';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { ITitleI18nConf } from '../page';
import AndroidPageContent from '../page/AndroidPageContent';
import CreateIcon from '@mui/icons-material/Create';
interface TabInfoType {
  label: string;
  value: string;
  icon: React.ReactNode;
}

function BottomBar() {
  return <Paper
    id="bottom-navigation"
    sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}
    elevation={3}>
    <NavBar />
  </Paper>;
}
export function NavBar() {
  const router = useRouter();
  const { pathname } = router;
  const { t } = useTranslation('app-ui/components/tabbar/content');
  const tabInfoList: TabInfoType[] = [
    { label: t('content.home'), value: '/', icon: <HomeIcon /> },
    { label: t('content.create'), value: '/script-creator', icon: <CreateIcon /> },
    { label: t('content.market'), value: '/market', icon: <StorefrontIcon /> },
    { label: t('content.settings'), value: '/settings', icon: <SettingsIcon /> },
  ];
  return (

    <BottomNavigation showLabels value={pathname}>
      {tabInfoList.map(e => (
        <BottomNavigationAction
          key={e.value}
          label={e.label}
          icon={e.icon}
          data-id={`tabbar-${e.value}`}
          className={pathname === e.value ? 'Mui-selected' : ''}
          onClick={() => {
            if (pathname === e.value) return;
            router.push(e.value);
          }}
        />
      ))}
    </BottomNavigation>
  );
}


// testWatchUpdates()
export function TabbarContainer({ children, titleConf }: {titleConf?:ITitleI18nConf} & PropsWithChildren)  {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <CssBaseline />
      <Stack direction={"column"} spacing={3}
      
      >
        <AndroidPageContent titleConf={titleConf}>
          {children}
        </AndroidPageContent>
        <BottomBar />
      </Stack>
    </Box>
  );
}

